import { gql, TypedDocumentNode } from "@apollo/client";
import {
  ProjectTeamMember,
  AggregatedProjectTeamMember,
  EditProjectTeamMemberMutationMutation,
  EditProjectTeamMemberMutationMutationVariables,
} from "generated/graphql";

export const teamMemberFragment: TypedDocumentNode<ProjectTeamMember> = gql`
  fragment teamMember_fields on ProjectTeamMember {
    id
    employeeId
    employee {
      id
      firstName
      lastName
      fullName
      activeDirectoryId
      isFormerEmployee
      profilePicture(size: 96)
    }
    projectId
    project {
      name {
        id
        de
        en
        fr
        it
      }
    }
    hours
    role
    connectedFields {
      field
      isConnected
    }
  }
`;

export const aggregatedTeamMemberFragment: TypedDocumentNode<AggregatedProjectTeamMember> = gql`
  fragment aggregatedTeamMemberFragment on AggregatedProjectTeamMember {
    id
    employeeId
  }
`;

export const teamMemberDraftFragment: TypedDocumentNode<ProjectTeamMember> = gql`
  ${teamMemberFragment}

  fragment teamMemberDraft_fields on ProjectTeamMember {
    approvedBy {
      __typename
    }
    approvedAt
    deletedAt
    draft {
      ...teamMember_fields
      modifiedBy {
        __typename
      }
      approvedAt
      deletedAt
    }
  }
`;

export const EDIT_TEAM_MEMBER_MUTATION: TypedDocumentNode<
  EditProjectTeamMemberMutationMutation,
  EditProjectTeamMemberMutationMutationVariables
> = gql`
  ${teamMemberFragment}
  ${teamMemberDraftFragment}

  mutation EditProjectTeamMemberMutation(
    $id: ID!
    $fields: InputProjectTeamMember!
  ) {
    editProjectTeamMember(id: $id, fields: $fields) {
      ...teamMember_fields
      ...teamMemberDraft_fields
    }
  }
`;
